import { useEffect, useRef, useState } from 'react';

import type React from 'react';

import { CONSTANTS } from '../../helpers/constants';
import { fieldError, setClass } from '../../helpers/utils';
import './styles.scss';
import { Chip } from '../Chip/index';
import { Cancel as IconCancel } from '../Icons/Cancel';

type EmailTagProps = {
	className?: string;
	type?: string;
	id?: string;
	name?: string;
	value?: string | string[];
	placeholder?: string;
	disabled?: boolean;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	onChange?: (e: any) => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	size?: string;
	positionIcon?: string;
	hookForm?: any;
	setEmails?: string | string[] | null;
};

export const EmailTag = ({
	className = '',
	type = 'text',
	id,
	name,
	value,
	placeholder,
	disabled = false,
	onBlur,
	onChange,
	onKeyDown,
	size,
	positionIcon,
	hookForm,
	setEmails,
}: EmailTagProps) => {
	const [isFocus, setIsFocus] = useState(false);
	const [isFill, setIsFill] = useState(false);
	const [email, setEmail] = useState([]);
	const [chips, setChips] = useState([]);
	const [currentValue, setCurrentValue] = useState('');
	const inputEl = useRef(null);
	const inputHidden = useRef(null);
	const validRegex = CONSTANTS.REGEX.EMAIL;
	const {
		register,
		setValue,
		watch,
		setError,
		clearErrors,
		formState: { errors },
	} = hookForm;

	const watchInput = watch?.(name, true);

	const typeSize = {
		medium: 'is-medium',
	};

	const isSize = typeSize[size] || '';

	const handleBlur = (event) => {
		const valueEntry = event.target.value;
		if (valueEntry.match(validRegex)) {
			setChips([...chips, valueEntry]);
			setEmail([...email, valueEntry]);
			setCurrentValue('');
			setValue(`email${name}`, '');
			clearErrors([name]);
		} else {
			// setCurrentValue("");
			// setValue(`email${name}`, "");
			setError(name, { type: 'custom', message: 'E-mail inválido' });
		}

		if (valueEntry === '') {
			clearErrors([name]);
		}

		setIsFocus(false);
		setIsFill(!isEmptyValue());

		if (typeof onBlur === 'function') {
			onBlur(event);
		}
	};

	const handleChange = (event) => {
		if (typeof onChange === 'function') {
			onChange(event);
		}
	};

	const handleKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === ',') {
			event.preventDefault();
			if (event.target.value.match(validRegex)) {
				setChips([...chips, event.target.value]);
				setEmail([...email, event.target.value]);
				setCurrentValue('');
				setValue(`email${name}`, '');
				clearErrors([name]);
			} else {
				setError(name, { type: 'custom', message: 'E-mail inválido' });
			}

			if (event.target.value === '') {
				clearErrors([name]);
			}
		}
		if (typeof onKeyDown === 'function') {
			onKeyDown(event);
		}
	};

	const isEmptyValue = () => {
		const elem = inputEl.current;
		const input = elem.querySelector('input');
		return !(input.value.trim().length > 0);
	};

	useEffect(() => {
		setIsFill(!isEmptyValue());
	}, []);

	useEffect(() => {
		setValue(name, email);
	}, [email]);

	useEffect(() => {
		if (setEmails && setEmails !== '') {
			const newArray = Array.isArray(setEmails)
				? setEmails
				: setEmails.split(',');
			setChips(newArray);
			setEmail(newArray);
		}
		if (setEmails === '') {
			setChips([]);
			setValue(name, null);
		}
	}, [setEmails]);

	useEffect(() => {
		setIsFill(!isEmptyValue());
	}, [watchInput]);

	const removeChip = (valueRemove) => {
		const newEmail = email.filter((item) => item !== valueRemove);
		setChips(chips.filter((chip) => chip !== valueRemove));
		setEmail(email.filter((item) => item !== valueRemove));

		if (typeof onChange === 'function') {
			onChange({ target: { value: newEmail, name } });
		}
	};

	return (
		<div
			className={setClass(`email-tag-content
    ${fieldError(errors, name) ? 'is-error' : ''}`)}
		>
			<div
				ref={inputEl}
				className={setClass(`input-email-tag email-tag
        ${isFill || isFocus ? 'is-fill' : ''}
        ${isSize}
        ${positionIcon ? `icon-${positionIcon}` : ''}
        ${disabled ? 'is-disabled' : ''}
        ${chips.length > 0 ? 'have-chips-content' : ''}
        ${className}`)}
			>
				{chips.length <= 0 && <label>{placeholder}</label>}
				{email.length > 0 &&
					chips.map((value, i) => {
						return (
							<div key={i} className={setClass('content-chips')}>
								<Chip title={value} iconClose={true}>
									<span>{value}</span>
									<button
										className="button"
										type="button"
										onClick={() => removeChip(value)}
									>
										<IconCancel width={20}></IconCancel>
									</button>
								</Chip>
							</div>
						);
					})}
				<input
					ref={inputHidden}
					type="hidden"
					name={name}
					id={id}
					{...register?.(name, {
						value: email,
					})}
				/>
				<input
					className={setClass(
						`
          ${chips.length > 0 ? 'have-chips' : ''}
        `,
					)}
					type={type}
					id={`email${id}`}
					name={`email${name}`}
					disabled={disabled}
					onFocus={() => setIsFocus(true)}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					onBlur={handleBlur}
					value={value}
					placeholder={chips.length > 0 ? `${placeholder}` : ''}
					{...register?.(`email${name}`, {
						onBlur: (e) => handleBlur(e),
						onChange: (e) => handleChange(e),
						value: currentValue,
					})}
				/>
			</div>
			{fieldError(errors, name) && (
				<span className="message-error">
					{(fieldError(errors, name) as any).message}
				</span>
			)}
		</div>
	);
};
